export const queryKeys = {
  COURSES: 'courses',
  TEACHERS: 'teachers',
  COURSE_BY_SLUG: 'course-by-slug',
  TEACHER_BY_SLUG: 'teacher-by-slug',
  TOP_TEACHERS: 'top-teachers',
  TOP_COURSES: 'top-courses',
  CATEGORY_COURSES: 'category-courses',
  TEACHER_TESTS: 'teacher-tests',
  RECOMMENDED_COURSES: 'recommended-courses',
  SORT_COURSES: 'sort-courses',
  COURSES_CATEGORY: '-courses-category'
};

export enum SocialMedias {
  INSTAGRAM = 'instagram',
  FACEBOOK = 'facebook',
  TELEGRAM = 'telegram',
  LINKEDIN = 'linkedin',
  YOUTUBE = 'youtube'
}

export enum CourseLesssonType {
  MODULAR = 'modular',
  SIMPLE = 'simple'
}